module.exports = __webpack_public_path__ + "static/media/9DESA17.0c6a1f20.jpg";